import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PictureInPictureIcon(props: IconProps) {
    return <Icon {...props} iconKey={"picture_in_picture"}/>
}
